module.exports = __webpack_public_path__ + "static/media/Gangster.00aa01ab.jpg";